export default "__VITE_ASSET__ff7cd4cd__"